import { ReadCsvDataWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('ReadCsvData')
export class ReadCsvDataNodeSchemaProvider extends SchemaProvider<ReadCsvDataWorkflowNode> {}
